export enum PromoStatus {
    All = 'All',
    Ongoing = 'Ongoing',
    Upcoming = 'Upcoming',
    Completed = 'Completed',
    Pending = 'Pending',
    Cancelled = 'Cancelled'
}
